import { initVideoListener, initEmbedListener } from "@api/utils_2020";

export default () => {
    initVideoListener();
    initEmbedListener();
    
};


